import { CONDOMINIUM_ACCENT_CLASSES } from "../constants/ownerPortfolio";

const EMPTY = "—";

export function formatPortfolioMoney(value: number | null): string {
  if (value === null || !Number.isFinite(value)) {
    return EMPTY;
  }

  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(value);
}

export function formatPortfolioDate(isoDate: string | null): string {
  if (!isoDate) {
    return EMPTY;
  }

  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(isoDate);
  if (!match) {
    return EMPTY;
  }

  return `${match[3]}/${match[2]}/${match[1]}`;
}

export function formatOccupancyRate(value: number | null): string {
  if (value === null || !Number.isFinite(value)) {
    return EMPTY;
  }

  return `${value.toLocaleString("pt-BR", { maximumFractionDigits: 1 })}%`;
}

export function formatDaysVacant(days: number | null): string | null {
  if (days === null || !Number.isFinite(days) || days <= 0) {
    return null;
  }

  if (days === 1) {
    return "1 dia vago";
  }

  return `${days} dias vago`;
}

export function formatInspectionSearchedAt(isoDate: string | null): string | null {
  if (!isoDate) {
    return null;
  }

  const parsed = new Date(isoDate);
  if (Number.isNaN(parsed.getTime())) {
    return null;
  }

  return new Intl.DateTimeFormat("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(parsed);
}

export function condominiumAccentClass(name: string | null): string {
  if (!name) {
    return "border-l-[#6e7681]";
  }

  let hash = 0;
  for (let index = 0; index < name.length; index += 1) {
    hash = (hash + name.charCodeAt(index)) % CONDOMINIUM_ACCENT_CLASSES.length;
  }

  return CONDOMINIUM_ACCENT_CLASSES[hash];
}
